import { Routes } from '@angular/router';

import { CamRoutes } from '@camelot/menu';
import { FeatureGuard } from '@camelot/user';

export enum ETasksRoute {
  tasks = 'tasks',
  myTasks = 'myTasks',
  allTasks = 'allTasks',
  myTeams = 'myTeams',
  list = 'list',
  view = 'view',
  summary = 'summary',
  allTodos = 'allTodos',
  myTodos = 'myTodos',
  dashboardManager = 'dashboardManager',
}

export enum EDashBoardManagerRoute {
  company = 'company',
  teams = 'teams',
  employees = 'employees',
}

CamRoutes.addRoute({
  key: ETasksRoute.tasks,
  url: 'tasks',
  children: [
    {
      key: ETasksRoute.summary,
      url: 'summary',
    },
    {
      key: ETasksRoute.myTasks,
      url: 'myTasks',
    },
    {
      key: ETasksRoute.myTeams,
      url: 'myTeams',
      children: [
        {
          key: ETasksRoute.list,
          url: 'list',
        },
        {
          key: ETasksRoute.tasks,
          url: 'tasks/:teamId',
        },
      ],
    },
    {
      key: ETasksRoute.allTasks,
      url: 'allTasks',
    },
    {
      key: ETasksRoute.allTodos,
      url: 'allTodos',
    },
    {
      key: ETasksRoute.myTodos,
      url: 'myTodos',
    },
    {
      key: ETasksRoute.dashboardManager,
      url: 'dashboardManager',
      children: [
        {
          key: EDashBoardManagerRoute.company,
          url: 'dashboard/company',
        },
        {
          key: EDashBoardManagerRoute.teams,
          url: 'dashboard/teams',
        },
        {
          key: EDashBoardManagerRoute.employees,
          url: 'dashboard/employees',
        },
      ],
    },
    {
      key: ETasksRoute.view,
      url: 'view/:id',
    },
  ],
});

export const tasksRoutes: Routes = [
  {
    path: '',
    redirectTo: CamRoutes.getUrl([ETasksRoute.tasks, ETasksRoute.summary]),
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () => import('./pages/tasks.component').then(c => c.TasksPage),
    children: [
      {
        canActivate: [FeatureGuard],
        data: { permissions: ['read:dashboard'] },
        loadComponent: () =>
          import('./pages/tasks/dashboard/tasks-dashboard.component').then(c => c.TasksDashboardPage),
        path: CamRoutes.getUrl([ETasksRoute.tasks, ETasksRoute.summary]),
      },
      {
        path: CamRoutes.getUrl([ETasksRoute.tasks, ETasksRoute.myTasks]),
        loadComponent: () => import('./pages/tasks/my-tasks-list/my-task-list.component').then(c => c.MyTaskListPage),
      },
      {
        path: CamRoutes.getUrl([ETasksRoute.tasks, ETasksRoute.allTasks]),
        loadComponent: () =>
          import('./pages/tasks/all-tasks-list/all-tasks-list.component').then(c => c.AllTasksListPage),
      },
      {
        path: CamRoutes.getUrl([ETasksRoute.tasks, ETasksRoute.allTodos]),
        loadComponent: () =>
          import('./pages/tasks/all-todos-list/all-todos-list.component').then(c => c.AllTodosListPage),
      },
      {
        path: CamRoutes.getUrl([ETasksRoute.tasks, ETasksRoute.myTodos]),
        loadComponent: () => import('./pages/tasks/my-todos-list/my-todos-list.component').then(c => c.MyTodosListPage),
      },
      {
        canActivate: [FeatureGuard],
        data: { permissions: ['read:dashboard'] },
        loadComponent: () =>
          import('./pages/tasks/dashboard-manager/dashboard-manager.component').then(c => c.DashboardManagerPage),
        path: CamRoutes.getUrl([ETasksRoute.tasks, ETasksRoute.dashboardManager]),
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: CamRoutes.getUrl([
              ETasksRoute.tasks,
              ETasksRoute.dashboardManager,
              EDashBoardManagerRoute.company,
            ]),
          },
          {
            path: CamRoutes.getUrl([ETasksRoute.tasks, ETasksRoute.dashboardManager, EDashBoardManagerRoute.company]),
            loadComponent: () =>
              import('./pages/tasks/dashboard-manager/company/company-reporting.component').then(
                c => c.CompanyReportingPage
              ),
          },
          {
            path: CamRoutes.getUrl([ETasksRoute.tasks, ETasksRoute.dashboardManager, EDashBoardManagerRoute.teams]),
            loadComponent: () =>
              import('./pages/tasks/dashboard-manager/teams/teams-reporting.component').then(c => c.TeamsReportingPage),
          },
          {
            path: CamRoutes.getUrl([ETasksRoute.tasks, ETasksRoute.dashboardManager, EDashBoardManagerRoute.employees]),
            loadComponent: () =>
              import('./pages/tasks/dashboard-manager/employees/employees-reporting.component').then(
                c => c.EmployeesReportingPage
              ),
          },
        ],
      },
      {
        path: CamRoutes.getUrl([ETasksRoute.tasks, ETasksRoute.myTeams]),
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: CamRoutes.getAbsoluteUrl([ETasksRoute.tasks, ETasksRoute.myTeams, ETasksRoute.list]),
          },
          {
            path: CamRoutes.getUrl([ETasksRoute.tasks, ETasksRoute.myTeams, ETasksRoute.list]),
            loadComponent: () => import('./pages/tasks/team-list/team-list.component').then(c => c.TeamListPage),
          },
          {
            path: CamRoutes.getUrl([ETasksRoute.tasks, ETasksRoute.myTeams, ETasksRoute.tasks]),
            loadComponent: () =>
              import('./pages/tasks/team-list/list/list-team-task.component').then(c => c.ListTeamTaskPage),
          },
        ],
      },
    ],
  },
  {
    path: CamRoutes.getUrl([ETasksRoute.tasks, ETasksRoute.view]),
    loadComponent: () => import('./pages/tasks/view/view.component').then(c => c.ViewPage),
  },
];
